import { useMediaQuery } from '~/hooks/useMediaQuery';
import { breakpoints } from '~/styles/media.css';

import type { ButtonEmphasis } from '../Button/Button.utils';

export type FloatingActionEmphasis = Extract<ButtonEmphasis, 'primary' | 'secondary'>;

/** Whether the viewport is narrow enough for header actions to float. */
export const useIsFloatingViewport = () => useMediaQuery(breakpoints.small);

/**
 * The emphasis an action floats with, or `null` when it stays in the header
 * (because the viewport is wide enough, or because a tertiary action never floats).
 */
export const useFloatingEmphasis = (emphasis: ButtonEmphasis) => {
  const isFloatingViewport = useIsFloatingViewport();

  return isFloatingViewport
    ? (
        {
          primary: 'primary',
          secondary: 'secondary',
          tertiary: null,
          status: 'primary',
        } satisfies Record<ButtonEmphasis, FloatingActionEmphasis | null>
      )[emphasis]
    : null;
};
